export default{
    /**
     * String utility functions
     */
    
    capitalizeFirstLetter: (str)=> {
        return str.charAt(0).toUpperCase() + str.substring(1);
    },


    lowercaseFirstLetter: (str)=> {
        return str.charAt(0).toLowerCase() + str.substring(1);
    }

};